import { useTranslation } from 'next-i18next';
export const useTravellersLabel = ({
  adultCount,
  childrenCount,
  short = false
}) => {
  const {
    t
  } = useTranslation();
  if (adultCount == null || adultCount <= 0) {
    return '';
  }
  const adultsLabel = t(short ? 'searchForm:travellersField.adultsLabelShort' : 'searchForm:travellersField.adultsLabel', {
    count: adultCount
  });
  if (childrenCount == null || childrenCount <= 0) {
    return adultsLabel;
  }
  const childrenLabel = t('searchForm:travellersField.childrenLabel', {
    count: childrenCount
  });
  return `${adultsLabel}, ${childrenLabel}`;
};